<kendo-chip
            [fillMode]="'none'"
            [rounded]="'full'"
            [removable]="false"
            [selected]="false"
            class="pointer-events-none"
            [ngClass]="statusColour()"
            style="font-size: 8px; padding: 3px 0px">
    <span class="text-uppercase line-height-0 px-1">{{ authorityName() }}</span>
</kendo-chip>